export class Mode {
  static LIST = 'LIST';
  static DETAIL = 'DETAIL';
  static PERSPECTIVE = 'PERSPECTIVE';
}

Object.freeze(Mode);
